// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__S13ZY","icon":"styles_icon__1Pfwy"};